import { render, staticRenderFns } from "./ReceiptTemplate.template.vue?vue&type=template&id=3666eb65&scoped=true&"
var script = {}
import style0 from "./ReceiptTemplate.template.vue?vue&type=style&index=0&id=3666eb65&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3666eb65",
  null
  
)

export default component.exports